/* eslint-disable */
function arrayToObject(key: string, arr: any[]): string {
  let result = '';
  for (const a of arr) {
    result += key + '=' + a + '&';
  }
  return result.slice(0, -1);
}

export function objectToUrlParams(obj: object): string {
  const cleanObj = obj;
  Object.keys(cleanObj).forEach((key) => cleanObj[key] == null && delete cleanObj[key]);
  return Object.keys(cleanObj)
    .map((key) => {
      if (Array.isArray(cleanObj[key])) {
        return arrayToObject(key, cleanObj[key]);
      }
      if (isDictionary(cleanObj[key])) {
        return dictionaryToObject(key, cleanObj[key]);
      }
      return key + '=' + cleanObj[key];
    })
    .join('&');
}

function dictionaryToObject(key: string, dict: { [key: string]: any }): string {
  let result = '';
  Object.keys(dict).forEach((keyDict: string) => {
    result += key + '[' + keyDict + ']=' + dict[keyDict] + '&';
  });
  return result.slice(0, -1);
}

function isDictionary(value: any): value is { [key: string]: any } {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
